import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04d36f74"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "table-page-search-submitButtons",
  style: { float: 'right', overflow: 'hidden' } || {}
}
const _hoisted_2 = { class: "button-collection-c" }
const _hoisted_3 = { class: "button-collection-r" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { style: {"color":"#42b983"} }, "撤回投保", -1))
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { style: {"color":"#42b983"} }, "撤回减保", -1))
const _hoisted_12 = { key: 3 }
const _hoisted_13 = ["onClick"]

import { ref, onMounted, reactive } from "vue";
import { FormInstance, message } from "ant-design-vue";
import {
  DownOutlined,
  UpOutlined,
  ExportOutlined,
  BarsOutlined,
  UserAddOutlined,
  UsergroupAddOutlined,
  UsergroupDeleteOutlined,
} from "@ant-design/icons-vue";
import { getPosList, getDic, revokePos, posExport } from "@/api/pos";
import { getBasicInfo } from "@/api/home";
import CheckPosDetailInfo from "./modules/CheckPosDetailInfo.vue";
import AddPosModal from "./modules/AddPosModal.vue";
import ReducePosModal from "./modules/ReducePosModal.vue";
import ChangePlanPackage from "./modules/ChangePlanPackage.vue";
import PosExportRecordModal from "./modules/PosExportRecordModal.vue";
import { useRoute } from "vue-router";
import store from "@/store";
import { debounce } from "@/utils/tools";
interface FormState {
  pageNum: null | number;
  pageSize: null | number;
  insuredName: string;
  employJobNumber: string;
  insuredIdNum: string;
  planPackageId: string | undefined;
  relation: string | undefined;
  type: string | undefined;
  hrPosState: string | undefined;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PosList',
  setup(__props) {

const route = useRoute();
const checkPosDetailInfo = ref(null);
const currentPage = ref(1);
const pageSizeConfig = ref(10);
const loading = ref<boolean>(false);
const totalData = ref(0);
const addPosModal = ref(null);
const reducePosModal = ref(null);
const posExportRecordModal = ref(null);
const changePlanPackage = ref(null);
const personalList = ref<Array<any>>([]);
const formRef = ref<FormInstance>();
const formState = reactive<FormState>({
  pageNum: 1,
  pageSize: 10,
  insuredName: "",
  employJobNumber: "",
  insuredIdNum: "",
  planPackageId: undefined,
  relation: undefined,
  type: undefined,
  hrPosState: undefined,
});
const openMore = ref<boolean>(false);
const columns = ref<Array<any>>([
  {
    title: "姓名",
    dataIndex: "insuredName",
    key: "insuredName",
    align: "left",
    width: "6%",
    ellipsis: true,
  },
  {
    title: "证件类型",
    dataIndex: "insuredIdTypeZh",
    key: "insuredIdTypeZh",
    align: "left",
    width: "7%",
    ellipsis: true,
  },
  {
    title: "证件号",
    dataIndex: "insuredIdNum",
    key: "insuredIdNum",
    align: "left",
    width: "13%",
    ellipsis: true,
  },
  {
    title: "出生日期",
    dataIndex: "insuredBirth",
    key: "insuredBirth",
    align: "left",
    width: "9%",
  },
  {
    title: "性别",
    dataIndex: "insuredGenderZh",
    key: "insuredGenderZh",
    align: "left",
    width: "5%",
  },
  {
    title: "人员类别",
    dataIndex: "relationZh",
    key: "relationZh",
    align: "left",
    width: "5%",
  },
  {
    title: "员工",
    dataIndex: "employeeName",
    key: "employeeName",
    align: "left",
    width: "6%",
    ellipsis: true,
  },
  {
    title: "保障方案",
    dataIndex: "planPackageName",
    key: "planPackageName",
    align: "left",
    width: "7%",
    ellipsis: true,
  },
  {
    title: "有效期",
    dataIndex: "startToEndTime",
    key: "startToEndTime",
    align: "left",
    ellipsis: true,
  },
  {
    title: "保全类型",
    dataIndex: "typeZh",
    key: "typeZh",
    align: "left",
    width: "5%",
  },
  {
    title: "状态",
    dataIndex: "ifValidZh",
    key: "ifValidZh",
    align: "left",
    width: "6%",
  },
  {
    title: "操作",
    dataIndex: "action",
    key: "action",
    width: "13%",
    align: "left",
  },
]);
const dataSource = ref<Array<any>>([]);
const relationDicList = ref<Array<any>>([]);
const planPackageDicList = ref<Array<any>>([]);
const idTypeDicList = ref<Array<any>>([]);
const genderDicList = ref<Array<any>>([]);
const branchDicList = ref<Array<any>>([]);
const bankDicList = ref<Array<any>>([]);
const hrPosStateList = ref<Array<any>>([]);
const posTypeList = ref<Array<any>>([]);

onMounted(() => {
  let isShowAddPosModal = store.getters.GET_IS_SHOW_ADD_POS_MODAL;
  if (isShowAddPosModal) {
    store.dispatch("setIsShowAddPosModal", false);
    showAddPosModal();
  }
  getTableData({});
  getDic({}).then((res) => {
    relationDicList.value = res.data.relationDicList;
    planPackageDicList.value = res.data.planPackageDicList;
    idTypeDicList.value = res.data.idTypeDicList;
    genderDicList.value = res.data.genderDicList;
    branchDicList.value = res.data.branchDicList;
    bankDicList.value = res.data.bankDicList;
    hrPosStateList.value = res.data.hrPosStateList;
    posTypeList.value = res.data.posTypeList;
  }).catch;
});

const handleExport = debounce(async (values: FormState) => {
  let resExport: any = await posExport(formState);
  if (resExport.code == 200) {
    message.success("导出成功，请前往导出记录查看下载");
  } else {
    message.error("导出失败");
  }
}, 500);

const handleSearch = (values: FormState) => {
  getTableData(values);
};
const onChangePage = (pageNum: number, pageSize: number) => {
  let data = formState as FormState;
  data.pageNum = pageNum;
  data.pageSize = pageSize;
  pageSizeConfig.value = pageSize;
  getTableData(data);
};
const handleFinishFailed = (errors: any) => {
  console.log(errors);
};
const showModalByCheckPosDetailInfo = (record: any) => {
  if (checkPosDetailInfo.value) checkPosDetailInfo.value.showModal(record);
};
const showAddPosModal = () => {
  if (addPosModal.value) {
    getBasicInfo().then((r) => {
      personalList.value = [];
      r.data.contractBriefInfo.personalList.forEach((r) => {
        if (r == "WORK_PLACE") {
          personalList.value.push({
            workPlace: "工作地",
          });
        } else if (r == "AFFILIATION") {
          personalList.value.push({
            affiliation: "三级机构",
          });
        } else if (r == "BANK_BRANCH") {
          personalList.value.push({
            bankBranch: "备注",
          });
        } else if (r == "WAGE") {
          personalList.value.push({
            wage: "工资/社保基数",
          });
        } else if (r == "ACCIDENT") {
          personalList.value.push({
            accident: "月薪倍数意外保额",
          });
        } else if (r == "OCC_CATE") {
          personalList.value.push({
            occCate: "职业类别",
          });
        } else if (r == "DEATH") {
          personalList.value.push({
            death: "月薪倍数定寿保额",
          });
        } else if (r == "CUSTOM_ACCIDENT") {
          personalList.value.push({
            customAccident: "自定义意外保额",
          });
        } else if (r == "CUSTOM_DEATH") {
          personalList.value.push({
            customDeath: "自定义定寿保额",
          });
        } else if (r == "CUSTOM_SERIOUS_ILLNESS") {
          personalList.value.push({
            customSeriousIllness: "自定义重疾保额",
          });
        }
      });
    });
    addPosModal.value.showModal();
  }
};
const showExportModal = () => {
  if (posExportRecordModal.value) posExportRecordModal.value.showModal();
};
const showReducePosModal = (record: any) => {
  if (reducePosModal.value) reducePosModal.value.showModal(record);
};
const showChangePlanPackage = (record: any) => {
  if (changePlanPackage.value) changePlanPackage.value.showModal(record);
};
const revokeAddOrReducePos = (id: number) => {
  let params = {
    hrBatchInfoId: id,
  };
  revokePos(params)
    .then((res: any) => {
      if (res.code == 200) {
        getTableData();
      } else {
        message.error(res.msg);
      }
    })
    .catch();
};
const Reset = () => {
  if (formRef.value) formRef.value.resetFields();
};
const getTableData = (data: any = {}) => {
  loading.value = true;
  getPosList(data)
    .then((res) => {
      dataSource.value = res.data.dataList;
      totalData.value = res.data.total;
      currentPage.value = res.data.pageNum;
      loading.value = false;
    })
    .catch();
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, { style: {"max-width":"1440px","margin":"0 auto","margin-top":"32px"} }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_a_form, {
            ref_key: "formRef",
            ref: formRef,
            model: formState,
            onFinish: handleSearch,
            onFinishFailed: handleFinishFailed,
            style: {"text-align":"left"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xxl: 6,
                    xl: 8,
                    lg: 8,
                    sm: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        label: "姓名：",
                        name: "insuredName"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: formState.insuredName,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.insuredName) = $event)),
                            placeholder: "请输入姓名"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xxl: 6,
                    xl: 8,
                    lg: 8,
                    sm: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        label: "证件号：",
                        name: "insuredIdNum"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: formState.insuredIdNum,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formState.insuredIdNum) = $event)),
                            placeholder: "请输入证件号"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (openMore.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_a_col, {
                          xxl: 6,
                          xl: 8,
                          lg: 8,
                          sm: 24
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, {
                              label: "人员类别：",
                              name: "relation"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select, {
                                  ref: "select",
                                  value: formState.relation,
                                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formState.relation) = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_select_option, { value: "" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("请选择")
                                      ]),
                                      _: 1
                                    }),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relationDicList.value, (foo) => {
                                      return (_openBlock(), _createBlock(_component_a_select_option, {
                                        key: foo.code
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(foo.name), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, {
                          xxl: 6,
                          xl: 8,
                          lg: 8,
                          sm: 24
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, {
                              label: "保全类型：",
                              name: "type"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select, {
                                  ref: "select",
                                  value: formState.type,
                                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((formState.type) = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_select_option, { value: "" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("请选择")
                                      ]),
                                      _: 1
                                    }),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(posTypeList.value, (foo) => {
                                      return (_openBlock(), _createBlock(_component_a_select_option, {
                                        key: foo.code
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(foo.name), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, {
                          xxl: 6,
                          xl: 8,
                          lg: 8,
                          sm: 24
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, {
                              label: "状态：",
                              name: "hrPosState"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select, {
                                  ref: "select",
                                  value: formState.hrPosState,
                                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((formState.hrPosState) = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_select_option, { value: null }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("请选择")
                                      ]),
                                      _: 1
                                    }),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hrPosStateList.value, (foo) => {
                                      return (_openBlock(), _createBlock(_component_a_select_option, {
                                        key: foo.code
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(foo.name), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, {
                          xxl: 6,
                          xl: 8,
                          lg: 8,
                          sm: 24
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, {
                              label: "工号：",
                              name: "employJobNumber"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input, {
                                  value: formState.employJobNumber,
                                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((formState.employJobNumber) = $event)),
                                  placeholder: "请输入工号"
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, {
                          xxl: 6,
                          xl: 8,
                          lg: 8,
                          sm: 24
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, {
                              label: "保障方案：",
                              name: "planPackageId"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select, {
                                  ref: "select",
                                  value: formState.planPackageId,
                                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((formState.planPackageId) = $event)),
                                  placeholder: "请选择"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_select_option, { value: "" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("请选择")
                                      ]),
                                      _: 1
                                    }),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(planPackageDicList.value, (foo) => {
                                      return (_openBlock(), _createBlock(_component_a_select_option, {
                                        key: foo.code
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(foo.name), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_col, {
                    xxl: 6,
                    xl: 8,
                    lg: 8,
                    sm: 24
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_1, [
                        _createVNode(_component_a_button, {
                          style: {"margin-left":"20px","width":"90px"},
                          type: "primary",
                          "html-type": "submit"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("查询")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_button, {
                          style: {"margin-left":"16px","width":"90px"},
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (Reset()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("重置")
                          ]),
                          _: 1
                        }),
                        _createElementVNode("a", {
                          onClick: _cache[8] || (_cache[8] = 
                  () => {
                    openMore.value = !openMore.value;
                  }
                ),
                          style: {"margin-left":"8px","color":"#42b983"}
                        }, [
                          _createTextVNode(_toDisplayString(openMore.value ? "收起" : "展开") + " ", 1),
                          (!openMore.value)
                            ? (_openBlock(), _createBlock(_unref(DownOutlined), { key: 0 }))
                            : (_openBlock(), _createBlock(_unref(UpOutlined), { key: 1 }))
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: showAddPosModal
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(UserAddOutlined)),
              _createTextVNode("单人增保")
            ]),
            _: 1
          }),
          _createVNode(_component_a_dropdown, null, {
            overlay: _withCtx(() => [
              _createVNode(_component_a_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: { name: 'posBatchAdd' } }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_menu_item, { key: "1" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(UsergroupAddOutlined)),
                          _createTextVNode("  批量增人")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: { name: 'posBatchReduce' } }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_menu_item, { key: "2" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(UsergroupDeleteOutlined)),
                          _createTextVNode("  批量减人")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                class: "button-c",
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 批量操作 "),
                  _createVNode(_unref(DownOutlined))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _unref(handleExport)
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ExportOutlined)),
              _createTextVNode("导出人员清单")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            class: "button-c",
            type: "default",
            onClick: showExportModal
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(BarsOutlined)),
              _createTextVNode("导出记录")
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_a_table, {
          dataSource: dataSource.value,
          columns: columns.value,
          pagination: {
        current: currentPage.value,
        onChange: onChangePage,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        total: totalData.value,
        pageSize: pageSizeConfig.value,
        showTotal: (totalData) => `共 ${totalData} 条数据`,
      },
          loading: loading.value,
          style: {"margin-top":"16px"}
        }, {
          bodyCell: _withCtx(({ column, text, record }) => [
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  _createElementVNode("a", {
                    onClick: ($event: any) => (showModalByCheckPosDetailInfo(record)),
                    style: {"color":"#42b983"}
                  }, "查看", 8, _hoisted_5),
                  _createVNode(_component_a_divider, { type: "vertical" }),
                  (record.type == '1' && record.ifValid != '-1')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                        _createElementVNode("a", {
                          onClick: ($event: any) => (showReducePosModal(record)),
                          style: {"color":"#42b983"}
                        }, "减保", 8, _hoisted_7),
                        _createVNode(_component_a_divider, { type: "vertical" })
                      ]))
                    : _createCommentVNode("", true),
                  (record.type == '1' && record.ifValid == '-1')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                        _createVNode(_component_a_popconfirm, {
                          title: "是否撤回投保？",
                          "ok-text": "确认",
                          "cancel-text": "取消",
                          onConfirm: ($event: any) => (revokeAddOrReducePos(record.id))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 2
                        }, 1032, ["onConfirm"]),
                        _createVNode(_component_a_divider, { type: "vertical" })
                      ]))
                    : _createCommentVNode("", true),
                  (record.type == '0' && record.ifValid == '-1')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                        _createVNode(_component_a_popconfirm, {
                          title: "是否撤回减保？",
                          "ok-text": "确认",
                          "cancel-text": "取消",
                          onConfirm: ($event: any) => (revokeAddOrReducePos(record.id))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 2
                        }, 1032, ["onConfirm"]),
                        _createVNode(_component_a_divider, { type: "vertical" })
                      ]))
                    : _createCommentVNode("", true),
                  (record.type == '1' && record.ifValid != '-1')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                        _createElementVNode("a", {
                          onClick: ($event: any) => (showChangePlanPackage(record)),
                          style: {"color":"#42b983"}
                        }, "变更层级", 8, _hoisted_13)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "loading"])
      ]),
      _: 1
    }),
    _createVNode(CheckPosDetailInfo, {
      ref_key: "checkPosDetailInfo",
      ref: checkPosDetailInfo,
      bankDicList: bankDicList.value,
      planPackageDicList: planPackageDicList.value,
      idTypeDicList: idTypeDicList.value,
      genderDicList: genderDicList.value,
      branchDicList: branchDicList.value,
      relationDicList: relationDicList.value
    }, null, 8, ["bankDicList", "planPackageDicList", "idTypeDicList", "genderDicList", "branchDicList", "relationDicList"]),
    _createVNode(AddPosModal, {
      ref_key: "addPosModal",
      ref: addPosModal,
      bankDicList: bankDicList.value,
      planPackageDicList: planPackageDicList.value,
      idTypeDicList: idTypeDicList.value,
      genderDicList: genderDicList.value,
      branchDicList: branchDicList.value,
      relationDicList: relationDicList.value,
      simple: personalList.value,
      onRefresh: getTableData
    }, null, 8, ["bankDicList", "planPackageDicList", "idTypeDicList", "genderDicList", "branchDicList", "relationDicList", "simple"]),
    _createVNode(ReducePosModal, {
      ref_key: "reducePosModal",
      ref: reducePosModal,
      bankDicList: bankDicList.value,
      planPackageDicList: planPackageDicList.value,
      idTypeDicList: idTypeDicList.value,
      genderDicList: genderDicList.value,
      branchDicList: branchDicList.value,
      relationDicList: relationDicList.value,
      onRefresh: getTableData
    }, null, 8, ["bankDicList", "planPackageDicList", "idTypeDicList", "genderDicList", "branchDicList", "relationDicList"]),
    _createVNode(PosExportRecordModal, {
      ref_key: "posExportRecordModal",
      ref: posExportRecordModal
    }, null, 512),
    _createVNode(ChangePlanPackage, {
      ref_key: "changePlanPackage",
      ref: changePlanPackage,
      bankDicList: bankDicList.value,
      planPackageDicList: planPackageDicList.value,
      idTypeDicList: idTypeDicList.value,
      genderDicList: genderDicList.value,
      branchDicList: branchDicList.value,
      relationDicList: relationDicList.value,
      onRefresh: getTableData
    }, null, 8, ["bankDicList", "planPackageDicList", "idTypeDicList", "genderDicList", "branchDicList", "relationDicList"])
  ], 64))
}
}

})